<template>
  <nav v-if="$vuetify.breakpoint.mdAndUp">
    <v-container :class="$vuetify.breakpoint.lgAndUp ? 'pa-0 px-12' : 'px-0 py-2'" fluid>
      <v-toolbar class="px-0 elevation-0 background toolbar-spacing w-100 green">
        <router-link :to="{ name: $constants.ROUTE_NAME.HOME }"><v-img src="@/assets/oly-logo.png" /></router-link>
        <AppointmentBox />
        <v-btn
          link
          text
          class="text-transform-none no-letter-spacing"
          :to="{ name: $constants.ROUTE_NAME.AGENT_DASHBOARD, query: { tab: 'cash_back' } }"
          v-if="currentUser && currentUser.roles === 'Agent'"
        >
          <AgentIcon :level="currentUser.ranking.replace('Style', '').trim().toUpperCase()" />
          <div :class="$vuetify.breakpoint.lgAndUp ? 'ml-4' : 'ml-2'">{{ agentRankName }}</div>
        </v-btn>
        <div>
          <v-btn link text class="text-capitalize no-letter-spacing" @click.prevent="logout" :loading="loggingOut">{{ $t('label.logOut') }}</v-btn>
        </div>
      </v-toolbar>
    </v-container>
  </nav>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AppointmentBox from '@/components/navbars/AppointmentBox.vue'
import AgentIcon from '@/components/AgentIcon.vue'
import { ROUTE_NAME } from '@/constants/route.constants'
import { localeHelper } from '@/utils'

export default {
  components: { AppointmentBox, AgentIcon },

  data() {
    return {
      loggingOut: false
    }
  },
  created() {
    if (this.currentUser.roles === 'Agent') this.getAgentStatus()
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    agentRankName() {
      let name = ''
      let rank = this.currentUser.ranking.replace('Style', '').trim().toLowerCase()
      switch (rank) {
        case 'silver':
          name = localeHelper.getMessage('label.silver')
          break
        case 'gold':
          name = localeHelper.getMessage('label.gold')
          break
        case 'platinum':
          name = localeHelper.getMessage('label.platinum')
          break
        case 'executive':
          name = localeHelper.getMessage('label.executive')
          break
      }
      return name
    }
  },
  methods: {
    ...mapActions('auth', { logoutAction: 'logout' }),
    ...mapActions('agent', ['getAgentStatus']),
    async logout() {
      this.loggingOut = true
      try {
        await this.logoutAction()
      } finally {
        this.loggingOut = false
        this.$router.push({ name: this.$constants.ROUTE_NAME.HOME })
        location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .toolbar-spacing .v-toolbar__content {
  justify-content: space-between;
}
</style>
